"use strict";
// Copyright © Veeam Software Group GmbH
Object.defineProperty(exports, "__esModule", { value: true });
exports.DISPLAY_CONFIG_VARIANTS = exports.DISPLAY_EU_HOURS = exports.DAYS = exports.CELL_STYLE_CONFIG = exports.MARGIN_RIGHT_LAST_MAIN_CELL = exports.BIG_WIDTH_CELL = exports.LEFT_POSITION_DAY_CAPTION = exports.MARGIN_LEFT_DAY_CAPTION = exports.MAIN_CELL_MARGIN = exports.MAIN_CELL_WIDTH = exports.L_SIZE = exports.M_SIZE = exports.S_SIZE = exports.STATUS_CELL = void 0;
const types_1 = require("../types");
const helpers_1 = require("../../helpers");
exports.STATUS_CELL = {
    UNSELECT_HOVER: 0,
    UNSELECTED: 1,
    SELECT_HOVER: 2,
    SELECTED: 3,
    DISABLED: 4
};
exports.S_SIZE = parseInt(helpers_1.SPACING_S, 10);
exports.M_SIZE = parseInt(helpers_1.SPACING_M, 10);
exports.L_SIZE = parseInt(helpers_1.SPACING_L, 10);
exports.MAIN_CELL_WIDTH = exports.M_SIZE;
exports.MAIN_CELL_MARGIN = exports.S_SIZE;
exports.MARGIN_LEFT_DAY_CAPTION = (exports.MAIN_CELL_WIDTH - exports.MAIN_CELL_MARGIN) / 2;
exports.LEFT_POSITION_DAY_CAPTION = 1 + exports.MAIN_CELL_WIDTH - exports.MARGIN_LEFT_DAY_CAPTION;
exports.BIG_WIDTH_CELL = 11 * (exports.MAIN_CELL_WIDTH + exports.MAIN_CELL_MARGIN) + exports.MAIN_CELL_WIDTH;
exports.MARGIN_RIGHT_LAST_MAIN_CELL = exports.MAIN_CELL_MARGIN + exports.MARGIN_LEFT_DAY_CAPTION;
exports.CELL_STYLE_CONFIG = {
    main: {
        width: exports.MAIN_CELL_WIDTH,
        height: exports.L_SIZE,
        margin: exports.MAIN_CELL_MARGIN
    },
    hourCaption: {
        marginLeft: exports.MARGIN_LEFT_DAY_CAPTION
    },
    hourDescription: {
        height: exports.M_SIZE,
        marginTop: 0
    }
};
exports.DAYS = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'];
exports.DISPLAY_EU_HOURS = [
    0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24
];
exports.DISPLAY_CONFIG_VARIANTS = {
    [types_1.BACKUP_MATRIX_FORMAT.eu]: {
        dayStartIndex: 0,
        hours: exports.DISPLAY_EU_HOURS
    },
    [types_1.BACKUP_MATRIX_FORMAT.us]: {
        dayStartIndex: 6,
        hours: [12, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]
    }
};
//# sourceMappingURL=constants.js.map